<div class="uploader-holder">
  <div>
    <div class="header">
      <div class="title-object">{{ "manager.uploader.title" | translate }}</div>
    </div>
  </div>

  <div class="summary-holder">
    <div
      [class]="
        uploaderType === 'reference'
          ? 'status-holder-reference'
          : 'status-holder-device'
      "
    >
      <div class="subtitle">
        {{ "misc.statusLabel" | translate | uppercase }}
      </div>
      @if (loading) {
        <div class="info">
          {{ "manager.uploader.loading" | translate }}
        </div>
      }
      @if (loading) {
        <div class="loader">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="loader-title">
            {{ "manager.uploader.loaderTitle" | translate }}
          </div>
          @if (loadingPercentage) {
            <div class="loader-title">{{ loadingPercentage }} %</div>
          }
        </div>
      }
      @if (!loading) {
        <div class="lines-holder">
          @for (info of referenceSummary.info; track i; let i = $index) {
            <div class="info">
              {{ info }}
            </div>
          }
        </div>
      }
    </div>
    <div
      [class]="
        uploaderType === 'reference'
          ? 'status-holder-reference'
          : 'status-holder-device'
      "
    >
      <div class="subtitle">{{ "misc.errors" | translate | uppercase }}</div>
      @if (!loading) {
        <div>
          @for (warning of referenceSummary.warnings; track i; let i = $index) {
            <div class="info warning">
              {{ warning }}
            </div>
          }
        </div>
      }
      @if (!loading && referenceSummary.details) {
        <div class="download-report">
          <app-button
            (clicked)="download()"
            labelPath="manager.uploader.dlDetails"
            iconRight="download"
            type="filled"
          ></app-button>
          <app-button
            (clicked)="back()"
            labelPath="manager.uploader.goBack"
          ></app-button>
        </div>
      }
    </div>
  </div>
</div>
